import styles from './audit-tabs.module.scss';
import { NavTabs } from './nav-tabs';
import { TabsActions } from './tabs-actions';

export const AuditTabs = () => {
  return (
    <div className={styles.container}>
      <NavTabs />
      <TabsActions />
    </div>
  );
};
